import { Link } from 'react-router-dom';

import { getRuntimeConfig } from '../services/runtime-config';
import { formatVersionLabel } from '../services/version-label';

/**
 * Version_Footer — an always-present, semantic page footer that surfaces the
 * running application version and (for non-production) the deploy environment.
 *
 * Reads the cached runtime config and delegates all display logic to the pure
 * `formatVersionLabel` helper. The footer is always rendered (even when both
 * parts are null, in which case it renders empty) and never throws.
 *
 * The middle-dot separator is purely decorative (`aria-hidden`); there is no
 * ARIA live region because the version is static, not an announced update.
 * Styling is token-only via the `.app-footer` class.
 *
 * Validates: Requirements 1.1, 1.3, 2.1, 6.2, 6.3, 6.4, 7.2, 7.3
 */
export function VersionFooter() {
  const config = getRuntimeConfig();
  const { versionText, envText } = formatVersionLabel(config?.version, config?.environment);

  return (
    <footer className="app-footer">
      {versionText && (
        <Link to="/changelog" aria-label={`${versionText} — view what's new`}>
          {versionText}
        </Link>
      )}
      {versionText && envText && <span aria-hidden="true"> · </span>}
      {envText && <span>{envText}</span>}
    </footer>
  );
}
